import Auth from '@aws-amplify/auth'
import { getCurrentUser } from 'aws-amplify/auth'
import { NavigateFunction } from 'react-router-dom'
export async function redirectIfNotLogin(navigate: NavigateFunction) {
	try {
		await getCurrentUser()
	} catch (e) {
		const isLog: boolean = JSON.parse(
			localStorage.getItem('amplify-redirected-from-hosted-ui') || 'false'
		)
		if (!isLog) navigate('/login')
	}
}

export async function redirectIfLogin(navigate: NavigateFunction) {
	try {
	  await getCurrentUser();
	  navigate('/status');
	} catch (e) {
	}
  }

export async function isUserLogged(setLogged: (value: boolean) => void) {
	try {
		await getCurrentUser()
		setLogged(true)
	} catch (e) {
		const isLog: boolean = JSON.parse(
			localStorage.getItem('amplify-redirected-from-hosted-ui') || 'false'
		)
		setLogged(isLog)
	}
}

export async function getUser() {
	const user = await Auth.currentUserInfo()
	return user
}
